import { ImageModel } from '.';

export interface BalanceSkin extends ImageModel {
  isDark: boolean;
}

export type BalanceSkinForm = Omit<BalanceSkin, 'id'>;
